import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getDadataAddresses = async (searchString) => {
  const data = await request.get(
    `/RentPlace/address/dadata`,
    {
      searchString,
    },
    'При загрузке адресов произошла ошибка',
    []
  );
  return data.sort((a, b) => a.orderNum - b.orderNum);
};

const useDadataAddresses = (search) =>
  useQuery([queries.dadataAddresses, search], () => getDadataAddresses(search), {
    placeholderData: [],
  });

export default useDadataAddresses;
